/* global Raven */
/* eslint-disable no-undef, no-underscore-dangle */
/* eslint-disable angular/factory-name */
// Too many occurrences to change Auth -> DxAuth in the scope of CoffeeScript conversion
angular.
module("digiexam.services").
factory("Auth", function Auth(
	$http,
	$rootScope,
	$location,
	$q,

	dxSession,
	ExamRepository,
	ArchiveRepository,
	dxRubricsRepository,
	DX_URLS,
	DxUser,
	dxBroadcastToAngular
) {
	"use strict";
	var _self = {
		login: function login(credentials) {
			function success(response) {
				if (!response.data) {
					var err = new Error("No `response.data` in Auth.login() > success()");
					Raven.captureException(err, {
						extra: {
							response: JSON.stringify(response),
						},
					});
				} else if (response.data.faults) {
					$rootScope.$broadcast("auth:loginfailed", response.data.faults, response.status, credentials.email);
					dxBroadcastToAngular.broadcastAuthEvent({
						type: "auth:loginfailed",
						args: {
							faults: response.data.faults,
							status: response.status,
							email: credentials.email,
						},
					});
					return $q.reject(response);
				} else {
					var user = new DxUser(response.data.user);
					dxSession.setSessionData(user, response.data.organizationRoles, response.data.intercom);
					$rootScope.$broadcast("auth:loginsuccess", dxSession.getUser());
					dxBroadcastToAngular.broadcastAuthEvent({
						type: "auth:loginsuccess",
						args: {
							user: dxSession.getUser(),
						},
					}); // Also broadcast this event to the Angular app
					return user;
				}
				return response;
			}

			function error(response) {
				var faults = [];
				try {
					faults = response.data.faults;
				} catch (err) {
					Raven.captureException(err, {
						extra: {
							method: "Auth.login() > error()",
							"response.data": JSON.stringify(response.data),
							"response.status": response.status,
						},
					});
				}
				$rootScope.$broadcast("auth:loginfailed", faults, response.status);
				dxBroadcastToAngular.broadcastAuthEvent({
					type: "auth:loginfailed",
					args: {
						faults: faults,
						status: response.status,
					},
				}); // Also broadcast this event to the Angular app
				return $q.reject(response);
			}

			return $http.post("/user/signin/", credentials).then(success, error);
		},

		register: function register(accountDetails) {
			$http.post("/user/create/", accountDetails).then(function handleResponse(response) {
				if (response.data.faults) {
					onFail(response);
				} else {
					dxSession.setSessionData(new DxUser(response.data.user), response.data.organizationRoles, response.data.kayako);
					$rootScope.$broadcast("auth:registersuccess", dxSession.getUser());
					dxBroadcastToAngular.broadcastAuthEvent({
						type: "auth:registersuccess",
						args: {
							user: dxSession.getUser(),
						},
					}); // Also broadcast this event to the Angular app
				}
			}, function handleReject(response) {
				onFail(response);
			});

			function onFail(response) {
				$rootScope.$broadcast("auth:registerfailed", response.data.faults);
				$q.reject(response);
			}
		},

		logout: function logout() {
			// Cleans out the session
			dxSession.destroySession();
			// Clean up the client side cache
			_self.clearCache();

			$location.path(DX_URLS.get("login"));
		},

		clearCache: function clearCache() {
			ExamRepository.exams = [];
			ArchiveRepository.groups = [];
			ArchiveRepository.courses = [];
			dxRubricsRepository.reset();
		},
	};
	return _self;
});
